<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { TabsIndicator } from 'reka-ui';

const props = defineProps<{ class?: HTMLAttributes['class'] }>();

const indicatorStyle = {
  width: 'var(--reka-tabs-indicator-size)',
  transform: 'translateX(var(--reka-tabs-indicator-position))',
};

const indicatorClass = cn(
  'absolute inset-0 left-0 rounded-lg border border-primary bg-white transition-transform duration-200 ease-in-out',
);
</script>

<template>
  <TabsIndicator
    :style="indicatorStyle"
    :class="cn(indicatorClass, props.class)"
  />
</template>
